import React, { createElement } from "react";
import PropTypes from "prop-types";
import {
  CardContainer,
  CardDateItem,
  CardBox,
  Paragraph
} from "./CardDetailStyled";
import { cardManager } from "../Cards";
import { showOldCardSelector } from "redux/selectors/config";
import { useSelector } from "react-redux";

const CardDetail = props => {
  const { type, isCurrent, date, isPrincipal, testId } = props;
  const showOldCards = useSelector(showOldCardSelector);
  const currentCard = cardManager(showOldCards, type);
  return (
    <CardContainer
      data-testid={`card-details-${testId}`}
      isPrincipal={isPrincipal}
      isCurrent={isCurrent}
      className={!isCurrent ? "history-card" : ""}
    >
      {!isCurrent && <CardDateItem>{date}</CardDateItem>}
      {currentCard ? (
        createElement(currentCard, props)
      ) : (
        <CardBox isCurrent>
          <Paragraph>{type}</Paragraph>
        </CardBox>
      )}
    </CardContainer>
  );
};

CardDetail.propTypes = {
  testId: PropTypes.string,
  caseId: PropTypes.string,
  date: PropTypes.string,
  type: PropTypes.string,
  isCurrent: PropTypes.bool,
  isPrincipal: PropTypes.bool,
  content: PropTypes.shape({
    description: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.string),
    date: PropTypes.string
  })
};

CardDetail.defaultProps = {
  testId: "card-detail",
  isCurrent: false,
  isPrincipal: false,
  date: "",
  type: "",
  caseId: "",
  content: {}
};

export default CardDetail;
